import styled from 'styled-components'
import Text from 'components/base/Text'
import css from '@styled-system/css'
import { Body } from '@careguide/typography'

export const Description = styled(Body)`
  white-space: pre-line;
  word-break: break-word;
`

export const Heading = styled(Text).attrs({ as: 'h1', variant: 'heading' })`
  text-transform: capitalize;
  ${css({
    fontSize: 3,
  })}
`
